import { Icon } from '@/components/Icon/Icon';
import { ApiError } from '@/lib/apiError';
import { useTranslations } from 'next-intl';
import React from 'react';

export const ErrorToast = ({
  error: { errorKey, errorKeyParameters, message },
}: {
  error: ApiError;
}) => {
  const t = useTranslations();
  return (
    <div className="flex items-center gap-400">
      <Icon
        icon="AlertTriangleFilled"
        className="h-600 w-600 text-colors-inverse-content-error"
      />
      <div className="flex flex-col">
        {errorKey && <span>{t(errorKey, errorKeyParameters)}</span>}
        {message && (
          <span className="text-colors-content-tertiary">{message}</span>
        )}
      </div>
    </div>
  );
};
